import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FilterConfigService {
  public getSelectItemGroups(): { parent: string; children: string[] }[] {
    return [
      {
        parent: 'asset.serviceType.label',
        children: ['asset.enum.serviceType.DATA_DELIVERY', 'asset.enum.serviceType.APP']
      },
      {
        parent: 'asset.language.label',
        children: ['asset.enum.language.GERMAN', 'asset.enum.language.ENGLISH']
      },
      {
        parent: 'asset.dataSource.label',
        children: [
          'asset.enum.dataSource.REST_API',
          'asset.enum.dataSource.CUSTOM_DATASOURCE_CONFIG',
          'asset.enum.dataSource.DATABASE'
        ]
      },
      {
        parent: 'asset.method.label',
        children: ['asset.enum.method.PUSH', 'asset.enum.method.PULL']
      }
    ];
  }

  public getSearchItemGroups(): { title: string }[] {
    return [
      { title: 'asset.publisher.label' },
      { title: 'asset.sovereign.label' },
      { title: 'asset.keywords.label' },
      { title: 'asset.subCategory.label' }
    ];
  }
}
